import { render, staticRenderFns } from "./Polina.vue?vue&type=template&id=70209515&"
import script from "./Polina.vue?vue&type=script&lang=ts&"
export * from "./Polina.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports